<script>
import { mapActions, mapGetters } from "vuex";
import i18n from "@/plugins/i18n";
import axios from "axios";

import StatusComponent from "./components/StatusComponent.vue";
import LoadingSpinner from "../../components/LoadingSpinner.vue";

export default {
  components: {
    StatusComponent,
    LoadingSpinner,
  },

  data() {
    return {
      /* input fields and their respective label values */
      myReportsFields: [
        {
          key: "my_report_name",
          label: i18n.t("myReports.header.my_report_name"),
          flex: 3,
        },
        {
          key: "report_type",
          label: i18n.t("myReports.header.report_type"),
          flex: 2
        },
        {
          key: "created_on",
          label: i18n.t("myReports.header.created_on"),
          flex: 2,
        },
        {
          key: "report_status",
          label: i18n.t("myReports.header.report_status"),
          flex: 1,
        },
        {
          key: "pdf",
          label: i18n.t("myReports.report"),
          flex: 1
        },
        {
          key: 'status',
          label: i18n.t("auditor.status.audit_status"),
          flex: 3,
        },
      ],

      auditButtonsTemplate: [
        {
          is_active: false,
          key: 'approved',
          text: i18n.t('auditor.status.approved'),
          callback: (report) => () => this._changeReportAuditStatus('approved', report),
          color: 'var(--sustainfinity-green)',
        },
        {
          is_active: false,
          key: 'recheck',
          text: i18n.t('auditor.status.recheck'),
          callback: (report) => () => this._changeReportAuditStatus('recheck', report),
          color: 'var(--sustainfinity-blue)',
        },
        {
          is_active: false,
          key: 'disapproved',
          text: i18n.t('auditor.status.disapproved'),
          callback: (report) => () => this._changeReportAuditStatus('disapproved', report),
          color: 'var(--invalid-input)',
        },
      ],

      myReportsItems: [],
      loadingMyReports: false,
      
      initialSelected: null,

      kpiStep: null,

      planID: null,
      planActive: false,

      loading: false,
    };
  },

  computed: {
    selectedCompanyId() {
      return Number(sessionStorage.getItem('audited_company_id'));
    },

    reportTypeOptions() {
      if (this.planID == 2) {
        return [
          {
            text: i18n.t("myReports.createModal.surveyReport"),
            value: "survey_report",
          },
        ]
      } else if (this.planID == 3) {
        return [
          {
            text: i18n.t("myReports.createModal.surveyReport"),
            value: "survey_report",
          },
          {
            text: i18n.t("myReports.createModal.strategy"),
            value: "strategy_report",
          },
        ]
      } else {
        return [
          {
            text: i18n.t("myReports.createModal.surveyReport"),
            value: "survey_report",
          },
          {
            text: i18n.t("myReports.createModal.strategy"),
            value: "strategy_report",
          },
          {
            text: i18n.t("myReports.createModal.sustainabilityReport"),
            value: "sustainability_report",
          },
        ]
      }
    },

    reportTypeName() {
      if (this.sustainabilityReportSelected) {
        return 'sustainability_report';
      } else if (this.reportTypeSelected && this.selectedTemplate) {
        return this.reportTypeSelected.concat(this.selectedTemplate);
      } else {
        return false;
      }
    },

    nextButtonDisabled() {
      if (!this.reportTypeSelected || !this.selectedSu1 || !this.selectedSu2 || this.kpisNotConfirmed) {
        return true;
      } else {
        return false;
      }
    },

    reportStatusPreparingExists() {
      return this.myReportsItems.some(item => item.report_status == "gettingready");
    },

    kpisNotConfirmed() {
      if (!this.reportTypeSelected) return false;

      if (this.reportTypeSelected.includes("sustainability_report")) {
        return this.kpiStep != null;
      } else {
        return false;
      }
    }

  },

  mounted() {
    this._getCompanyLicenceState();
    this.myReports();
  },

  methods: {
    ...mapActions("reports", [
      "getMyReports",
      "downloadMyReport",
    ]),

    ...mapActions('auditor', [
      'changeReportAuditStatus',
      'updateReportAuditorComment',
    ]),

    myReports() {
      this.myReportsItems = [];
      this.loadingMyReports = true;
      const params = {
        company_id: this.selectedCompanyId,
        is_deleted: false,
      };
      this.getMyReports(params)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.report_type != "carbon_report") {
              this.myReportsItems.push(element);
            }
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
        .finally(() => {
          this.checkReportStatusExists();
          this.loadingMyReports = false;
        });
    },

    async downloadReport(data) {
      if (data.report_status === 'gettingready' || data.report_status === 'failed') return;

      try {
        const requestPayload = {
          my_report_id: data.my_report_id,
          company_id: data.company_id
        };

        const response = await axios.post('/api/myreport/downloadmyreport', requestPayload, {
          responseType: 'blob',
          withCredentials: true,
        });
        const blob = new Blob([response.data], { type: 'application/msword' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', data.my_report_name);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toast.open({
          message: error,
          type: "error",
          duration: 5000,
          dismissible: true,
        });
      }
    },
    reportTypeText(reportType) {
      if (reportType.includes("survey_report")) {
        return this.reportTypeOptions[0].text
      }
      if (reportType.includes("strategy_report") && this.reportTypeOptions.length >= 2) {
        return this.reportTypeOptions[1].text
      }
      if (reportType.includes("sustainability_report") && this.reportTypeOptions.length >= 3) {
        return this.reportTypeOptions[2].text
      }
    },

    async openCreateReportModal() {
      if (this.nextButtonDisabled) {
        alert(":)");
        return;
      }

      this.createMyReportModal = true;
    },

    checkReportNameExists(_name) {
      const exists = this.myReportsItems.some(item => item.my_report_name == _name);
      return exists;
    },

    checkReportStatusExists() {
      const exists = this.myReportsItems.some(item => item.report_status == "gettingready")
      if (exists == true) {
        setTimeout(() => {
          this.myReports();
        }, 60000);
      }
    },

    // auditor operations //

    _changeReportAuditStatus(s, report) {
      const params = {
        my_report_id: report.my_report_id,
        status: s
      };

      this.changeReportAuditStatus(params)
        .then( res => {
          report.report_audit_status = s;
          this.$notify('success', '', true);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
    },

    _updateReportAuditorComment(c, report) {
      const params = {
        my_report_id: report.my_report_id,
        comment: c
      };

      this.updateReportAuditorComment(params)
        .then( res => {
          this.$notify('success', '', true);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
    },


    // LICENCE CONTROL //

    ...mapGetters("app", ["getCompanyLicence"]),

    _getCompanyLicenceState() {
      const licence = this.getCompanyLicence();

      this.planID = licence.plan_id;
      this.planActive = licence.is_active;
    }
  },
};
</script>

<template>
  <div class="report-items-wrapper">
    <div v-if="loadingMyReports" class="flex-all-centered-row">
      <LoadingSpinner style="font-size: 2em;"/>
    </div>

    <div class="reports-table" v-else>
      <div class="reports-header-row">
        <div v-for="header in myReportsFields" :key="header.key"
          :style="{ flex: header.flex }"
        >
          {{ header.label }}
        </div>
      </div>

      <div class="reports-info-rows" v-for="report in myReportsItems" :key="report.my_report_id">
        <div :style="{ flex: myReportsFields[0].flex }">
          {{ report.my_report_name }}
        </div>
        <div :style="{ flex: myReportsFields[1].flex }">
          {{ reportTypeText(report.report_type) }}
        </div>
        <div :style="{ flex: myReportsFields[2].flex }">
          {{ report.created_on | dateFormat }}
        </div>
        <div :style="{ flex: myReportsFields[3].flex }">
          {{ $t(`myReports.misc.${report.report_status}`) }}
        </div>
        <div class="edit-delete-buttons" :style="{ flex: myReportsFields[4].flex }">
          <i class="fa-solid fa-file-arrow-down" @click="downloadReport(report)"
            :class="{'disabled-icon': report.report_status === 'gettingready' || report.report_status === 'failed'}"
          ></i>
        </div>
        <div :style="{ flex: myReportsFields[5].flex }">
          <StatusComponent 
            style="width: 80%; justify-self: center;"
            :buttons="
              auditButtonsTemplate.map(btn => ({
                ...btn,
                is_active: report.report_audit_status === btn.key,
                callback: btn.callback(report)
              })
            )"
          />
        </div>

        <div class="auditor-comments-section">
          <div>
            {{ $t('auditor.status.comments') }}:
          </div>
          <textarea v-model="report.auditor_comments"
            @change="_updateReportAuditorComment(report.auditor_comments, report)"
            maxlength="2000"
          ></textarea>
        </div>
      </div>

      <div class="report-info-rows" v-if="myReportsItems.length == 0">
        {{ $t('noData.text') }}
      </div>
    </div>

    <br/><br/>
  </div>
</template>


<style scoped lang="scss">
.report-items-wrapper {
  width: 100%;
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  padding: 1em 0 1em 0;
}

.reports-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.reports-header-row {
  background-color: var(--sustainfinity-navy);
  color: white;
  border-top-right-radius: 1em;
  border-top-left-radius: 1em;

  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  align-content: flex-start;

  > div {
    padding: .75em .5em .75em .5em;
    
    border-right: thin solid whitesmoke;
    
    display: flex;
    align-items: center;

    &:last-of-type {
      border-right: 0 !important;
    }
  }
}

.reports-info-rows {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  flex-wrap: wrap;

  border-bottom: thin solid gray;
  background-color: whitesmoke;

  &:last-of-type {
    border-bottom: 0 !important;
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
  }

  > div {
    padding: .5em;
  }
}

.edit-delete-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;

  >.fa-file-arrow-down {
    color: var(--sustainfinity-green);
  }

  >.fa-pen-to-square {
    color: var(--sustainfinity-blue);
  }

  >.fa-trash-can {
    color: var(--invalid-input);
  }

  > i {
    font-size: 1.2em;
    transition: all 150ms;
    cursor: pointer;

    &:hover {
      filter: brightness(115%);
    }
  }

  > .disabled-icon {
    color: gray !important;
    pointer-events: none !important;
  }
}

.auditor-comments-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  border-top: thin solid lightgray;

  div > {
    font-weight: bold;
    color: black;
  }

  > textarea {
    padding: .25em;
    width: 100%;
    min-height: 4em;
    font-size: .9em;
    border-radius: .25em;

    border: 0;
    outline: thin solid lightgray;

    &:focus {
      border: 0 !important;
      outline: thin solid black;
    }
  }
}
</style>